<proffeo-ui-page-wrapper>
  <div
    pageActions
    class="flex w-full justify-between"
  >
    <proffeo-ui-input
      (debouncedValueChange)="searchValue.set($event)"
      [debounceMs]="300"
      variant="search"
      placeholder="placeholders.search-input"
    />
    <proffeo-ui-button
      (clicked)="openCreateCompanyIndustryDialog()"
      [fontIcon]="'add'"
      variant="accent"
      text="{{ 'company-industries.add-industry' | translate }}"
    />
    <proffeo-ui-button
      (clicked)="openCreateCompanyIndustryDialog()"
      variant="accent"
      fontIcon="add"
      class="button fixed bottom-5 right-5 lg:bottom-10 lg:right-10 flex cursor-pointer z-10"
    ></proffeo-ui-button>
  </div>
  <div class="w-full pt-3 lg:pt-6">
    <div
      [proffeoSpinner]="getCompanyIndustriesPageList() === undefined"
      proffeoSpinnerSize="lg"
      class="flex min-h-48 w-full flex-col gap-2 lg:overflow-x-auto lg:rounded-md lg:border-1 lg:border-proffeo-border lg:bg-proffeo-surface"
    >
      @if (getCompanyIndustriesPageList()?.content?.length > 0) {
        <proffeo-company-industries-list
          (deleteCompanyIndustry)="deleteCompanyIndustry($event)"
          [companyIndustries]="$safeNavigationMigration(getCompanyIndustriesPageList()?.content)"
          class="w-full"
        ></proffeo-company-industries-list>

        @if (getCompanyIndustriesPageList().content?.length > 0 && (searchValue()?.length === 0 || !searchValue())) {
          <proffeo-pagination
            [page]="page"
            [limit]="limit"
            [total]="$safeNavigationMigration(getCompanyIndustriesPageList()?.total)"
          ></proffeo-pagination>
        }
      } @else if (getCompanyIndustriesPageList()) {
        <div class="flex w-full items-center justify-center p-4">
          <p>{{ 'placeholders.no-results-found' | translate }}</p>
        </div>
      }
    </div>
  </div>
</proffeo-ui-page-wrapper>
